import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wagers-container" }
const _hoisted_2 = { class: "wagers-card desktop-only" }
const _hoisted_3 = { class: "table-container" }
const _hoisted_4 = { class: "wagers-table" }
const _hoisted_5 = { class: "total-return-header" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  colspan: "8",
  class: "loader-cell"
}
const _hoisted_8 = { class: "table-loader" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  colspan: "8",
  class: "empty-cell"
}
const _hoisted_11 = { class: "detail-cell" }
const _hoisted_12 = ["title", "onClick"]
const _hoisted_13 = {
  key: 0,
  class: "loading-cards"
}
const _hoisted_14 = { class: "card-loader" }
const _hoisted_15 = {
  key: 1,
  class: "empty-cards"
}
const _hoisted_16 = {
  key: 3,
  class: "mobile-cards-loading-overlay",
  "aria-live": "polite",
  "aria-busy": "true"
}
const _hoisted_17 = { class: "card-loader" }

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import type { Transaction } from '@/stores/transactions'
import WagerCard from './WagerCard.vue'
import { formatCurrency } from '@/utils/currency'
import { useTheme } from '@/composables/useTheme'


export default /*@__PURE__*/_defineComponent({
  __name: 'TransactionsTable',
  props: {
    transactions: {},
    loading: { type: Boolean }
  },
  emits: ["view-details", "rebet", "copy-success", "copy-failed"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { t } = useI18n()
const { currentThemeName } = useTheme()
const useWonLostLabels = computed(() => currentThemeName.value === 'wsb')

const formatStatusLabel = (item: Transaction) => {
  const status = item.bet_status
  if (!useWonLostLabels.value || String(status).toLowerCase() !== 'settled') {
    return status
  }
  return parseFloat(String(item.total_winnings || 0)) > 0 ? t('wagers.won') : t('wagers.lost')
}

const formatStatusClass = (item: Transaction) => {
  const status = item.bet_status
  if (!useWonLostLabels.value || String(status).toLowerCase() !== 'settled') {
    return String(status).toLowerCase()
  }
  return parseFloat(String(item.total_winnings || 0)) > 0 ? 'won' : 'lost'
}

const tableRows = computed(() => {
  return props.transactions
})

const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');
  
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

const handleRebet = () => {
  emit('rebet')
}

const getDrawsPlayed = (item: Transaction) => {
  const count = item.draws_played
  if (count === undefined || count === null) {
    return '—'
  }
  return count
}

const getTotalReturn = (item: Transaction) => {
  if (item.bet_status.toLowerCase() === 'open') {
    return t('wagers.tbc')
  }
  return formatCurrency(item.total_winnings, item.currency_symbol)
}

const getStatusClass = (item: Transaction) => {
  if (item.bet_status.toLowerCase() === 'settled' && item.total_winnings === '0.00') {
    return 'settled-zero'
  }
  return ''
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('wagers.date')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('wagers.transId')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('wagers.drawsPlayed')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('wagers.description')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('wagers.totalBetAmount')), 1),
              _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t('wagers.totalReturn')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('wagers.status')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('wagers.detail')), 1)
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_ctx.loading && tableRows.value.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                  _createElementVNode("td", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "spinner" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('wagers.loadingTransactions')), 1)
                    ])
                  ])
                ]))
              : (tableRows.value.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                    _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.$t('wagers.noTransactions')), 1)
                  ]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(tableRows.value, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id,
                      class: "transaction-row"
                    }, [
                      _createElementVNode("td", null, _toDisplayString(formatDate(item.created_at)), 1),
                      _createElementVNode("td", null, _toDisplayString(item.id), 1),
                      _createElementVNode("td", null, _toDisplayString(getDrawsPlayed(item)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$t('wagers.wager')), 1),
                      _createElementVNode("td", null, _toDisplayString(item.currency_symbol) + " " + _toDisplayString(item.total), 1),
                      _createElementVNode("td", null, _toDisplayString(getTotalReturn(item)), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass(['status', formatStatusClass(item), getStatusClass(item)])
                        }, _toDisplayString(formatStatusLabel(item)), 3)
                      ]),
                      _createElementVNode("td", _hoisted_11, [
                        _createElementVNode("button", {
                          class: "details-icon-button",
                          title: _ctx.$t('wagers.detail'),
                          onClick: _withModifiers(($event: any) => (_ctx.$emit('view-details', item)), ["stop"])
                        }, _cache[4] || (_cache[4] = [
                          _createElementVNode("img", {
                            src: "/img/icons/info.svg",
                            alt: "Details",
                            class: "info-icon"
                          }, null, -1)
                        ]), 8, _hoisted_12)
                      ])
                    ]))
                  }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["mobile-cards mobile-only", { 'mobile-cards--refreshing': _ctx.loading && tableRows.value.length > 0 }])
    }, [
      (_ctx.loading && tableRows.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "spinner" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('wagers.loadingTransactions')), 1)
            ])
          ]))
        : (tableRows.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('wagers.noTransactions')), 1)
            ]))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(tableRows.value, (item) => {
              return (_openBlock(), _createBlock(WagerCard, {
                key: item.id,
                transaction: item,
                onViewDetails: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('view-details', $event))),
                onRebet: handleRebet,
                onCopySuccess: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('copy-success'))),
                onCopyFailed: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('copy-failed')))
              }, null, 8, ["transaction"]))
            }), 128)),
      (_ctx.loading && tableRows.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "spinner" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('wagers.loadingTransactions')), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})